module.exports = __webpack_public_path__ + "img/q-2-2@2x.a8d586f4.png";